import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { PipesModule } from "@shared/pipes/pipes.module";
import { SummaryFieldComponent } from "./summary-field.component";

@NgModule({
  declarations: [SummaryFieldComponent],
  imports: [CommonModule, PipesModule],
  exports: [SummaryFieldComponent]
})
export class SummaryFieldModule{}